import { css } from 'styled-components';

var stretchButton = css(["width:", ";"], function (props) {
  return props.$stretch ? "100%;" : "fit-content;";
});

export { stretchButton };
